<template>
  <div class="container">
    <!-- 附件图片管理 -->
    <div class="title">
      <span>附件图片管理</span>
    </div>
    <div class="center">
        <div class="left">
            <div style="margin-bottom: 10px;">图片上传:</div>
             <uploadImgJava :data="uploadDataImg" />
        </div>
        <div class="right">
             <div style="margin-bottom: 10px;">文件上传:</div>
             <uploadFileCode :data="uploadData" />
        </div>

    </div>
  </div>
</template>

<script>
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
export default {
     components: {
    uploadFileCode,
    uploadImgJava,
    },
    data() {
        return {
          uploadData: {
            code: '',
            type: 'payment-appendix',
          },
         uploadDataImg: {
            code: '',
            type: 'payment-certificate',
          },

        }
    }

}
</script>

<style lang="less" scoped>
.container {
    .title {
     font-weight: 700;
    /* float: left; */
    margin-left: 0px;
    color: black;
    margin: 10px 0;

}
   .center {
       padding: 0 10px;
    display: flex;
    justify-content: space-between;
   }

}
</style>